<template>
    <div class="section" id="galeria">
        <div class="container-fluid fadeInUp wow" data-wow-duration="0.5s">
        <h3>Proyectos Recientes</h3>
        <div class="line bg-primary"></div>
        
        <div class="mt-5 no-gutters row row-cols-2 row-cols-md-3 row-cols-lg-4">
            <div class="col"><img src="../assets/galeria/1.jpg" alt="" width="100%"></div>
            <div class="col"><img src="../assets/galeria/8.jpg" alt="" width="100%"></div>
            <div class="col"><img src="../assets/galeria/9.jpg" alt="" width="100%"></div>            
            <div class="col"><img src="../assets/galeria/10.jpg" alt="" width="100%"></div>            
            <div class="col"><img src="../assets/galeria/11.jpg" alt="" width="100%"></div>            
            <div class="col"><img src="../assets/galeria/5.jpg" alt="" width="100%"></div>
            <div class="col"><img src="../assets/galeria/2.jpg" alt="" width="100%"></div>
            <div class="col"><img src="../assets/galeria/4.jpg" alt="" width="100%"></div>
            <div class="col"><img src="../assets/galeria/3.jpg" alt="" width="100%"></div>
            <div class="col"><img src="../assets/galeria/6.jpg" alt="" width="100%"></div>
            <div class="col"><img src="../assets/galeria/7.jpg" alt="" width="100%"></div>
            <div class="col"><img src="../assets/galeria/12.jpg" alt="" width="100%"></div>
        </div>


        </div>
    </div>
</template>

<script>
export default {
    name : "Galeria"
}
</script>